import React, { useState, useEffect, useContext, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import NotificationPanel from "./notificationPanel";
import useShvaToken from "../../hooks/useShvaToken";
import loginSuccess from "../../hooks/useLoginSuccess";
import Header from './Header';
import SubHeader from "./SubHeader";
import useLogoutCleanup from '../../hooks/useLogoutCleanup';
import { useLoading } from '../../context/LoadingContext';
import '../../style/default.css';
import Report from '../../components/report';
import Footer from "./Footer";
import useIdleSessionTimeout from '../../hooks/useIdleSessionTimeout';
import powerBISettings from "../../configs/powerBISettings";
import { getUserType, getCustomerTenants, getPowerBIAccessToken, setUserTypeAsParameter, getHVAObjectListForUser, openFlareDocument,validateConcurrentSession } from '../../services/reportServices';
import {getReportNotificationsIAmMemberOf} from '../../services/reportNotificationService';
import { UserContext } from '../../context/UserContext';
import SubscriptionMgtMain from "../subscription/SubscriptionMgtMain";
import QueryBuilder from "../customQueryBuilder/querybuilder";
import NotificationMessagePopup from "./NotificationMessagePopup";
import { Snackbar, Alert, Button, Box } from '@mui/material';
import { removeLocalStorageItems } from '../../utils/removeLocalStorageUtility';
import { validateLoginPrerequisite, deletePreviousActiveUser, getTenantTimeout, updateActiveUser } from '../../services/loginPrerequisiteService';
import useSessionExtensionInterceptor from '../../hooks/useSessionExtensionInterceptor';  
import { validateConcurrentSessionIfEnabled } from '../../utils/validateConcurrentSessionUtil';  

function Home({ setNotificationPanelOpen }) {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const logoutCleanup = useLogoutCleanup();
  const { loading } = useLoading();
  const { setUserContext } = useContext(UserContext);
  const reportRef = useRef();

  // === State ===
  const [errorMessage, setErrorMessage] = useState("");
  const [errorDetail, setErrorDetail] = useState("");
  const [showErrorDetail, setShowErrorDetail] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [notificationPanelOpen, setLocalNotificationPanelOpen] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const [userType, setUserType] = useState("");
  const [extendClicked, setExtendClicked] = useState(false);
  const [loginConfigured, setLoginConfigured] = useState(false);
  const [showMgtConsole, setShowMgtConsole] = useState(true);
  const [showSubscriptionMgt, setShowSubscriptionMgt] = useState(false);
  const [showCustomQueryBuilder, setShowCustomQueryBuilder] = useState(false);

 const [isServiceAdmin, setIsServiceAdmin] = useState(false);
 const [isTenantAdmin, setIsTenantAdmin] = useState(false);
 const [isSupportImplUser, setIsSupportImplUser] = useState(false);
 const [isBackupCapacityActive, setIsBackupCapacityActive] = useState(false);
 const [userId, setUserId] = useState(0);
 const [userTenantId, setUserTenantId] = useState(0);
 const [tenantAdminUrlCaption, setTenantAdminUrlCaption] = useState('');
 const [tenantAdminUrl, setTenantAdminUrl] = useState('');
 const [showTenantAdminLink, setShowTenantAdminLink] = useState(false);
 const [showNotificationLink, setShowNotificationLink] = useState(false);
 const [showCustomQueryLink, setShowCustomQueryLink] = useState(false);
 const [tenantNotifications, setTenantNotifications] = useState([]);
 const [hvaObjectSubscriptionManagementDisplayName, setHvaObjectSubscriptionManagementDisplayName] = useState('Subscriptions Management');
 const [tenants, setTenants] = useState([]);
 const [notificationForPanel, setNotificationForPanel] = useState([]);
 const [selectedTenant, setSelectedTenant] = useState("Select Tenant");
  const [accesstoken, setAccesstoken] = useState('');
const [powerBIAccessTokenTime, setPowerBIAccessTokenTime] = useState('');
const [rlsUser, setRlsUser] = useState("");
const [contentPackListPinned, setContentPackListPinned] = useState([]);
const [showNotificationPopUp, setShowNotificationPopUp] = useState(false);
const [subscriptionMngtPrivileges, setSubscriptionMngtPrivileges] = useState({});
const [defaultTimeout, setDefaultTimeout] = useState(10); // in minutes
const HVAObjectSubscriptionManagementName = "Subscriptions Management";
const [loginChecked, setLoginChecked] = useState(false);
const [loginPrereqChecked, setLoginPrereqChecked] = useState(false);
const [isJwtAuthenticated, setIsJwtAuthenticated] = useState(false);  

  // Use the custom hook for SHVA token
  const shvaToken = useShvaToken();

  // === Authentication ===
/*   useEffect(() => {
    setIsAuthenticated(accounts.length > 0);
  }, [accounts]); */

  
useEffect(() => {  
  const checkJwtAuth = () => {  
    const isJwtMode = localStorage.getItem('jwt_authenticated') === 'true';  
    setIsJwtAuthenticated(isJwtMode);  
    setIsAuthenticated(accounts.length > 0 || isJwtMode);  
  };  
    
  checkJwtAuth();  
    
  // Listen for storage changes from other tabs  
  const handleStorageChange = (e) => {  
    if (e.key === 'jwt_authenticated') {  
      checkJwtAuth();  
    }  
  };  
    
  window.addEventListener('storage', handleStorageChange);  
  return () => window.removeEventListener('storage', handleStorageChange);  
}, [accounts]); // Only depend on accounts

  const handleLogin = async () => {
    await instance.loginRedirect();
  };

  const handleLogout = async () => {
    await logoutCleanup(shvaToken, '', navigate); // Clean up storage and navigate
    await instance.logoutRedirect();
  };

  // === Notification Panel ===
  const openNotificationPanel = () => {
    setLocalNotificationPanelOpen((prev) => !prev);
    setNotificationPanelOpen((prev) => !prev);
  };

 
  // === Page Title ===
  //loginSuccess(isAuthenticated, setPageTitle, setUserType, setDefaultTimeout, navigate, instance, setLoginChecked);

// Validate login prerequisites after loginSuccess
useEffect(() => {
  if (!isAuthenticated ) return;
  //setLoginPrereqChecked && setLoginPrereqChecked(false); // Reset before starting
  // adding logic of useloginSuccess 

  const shva = localStorage.getItem("shva");
  if (!shva || shva === "undefined" || shva === "") {
    console.log('No SHVA found. Setting default SHVA.');
    // Default SHVA
    //localStorage.removeItem("Title");
    localStorage.setItem("shva", "R2zVUZUw0J/DR44Wub7X/Q==");
    setPageTitle("");
    setUserType("");
  
    // Fetch tenant timeout & login configuration
    getTenantTimeout()
      .then((result) => {
        const loginConfiguration = result.data;
  
        // Store values in localStorage and update React state
        localStorage.setItem("postLogoutRedirectUri", loginConfiguration.postLogoutRedirectUri);
        localStorage.setItem("shva", decodeURIComponent(loginConfiguration.shva));  
        localStorage.setItem("Title", loginConfiguration.title);
        localStorage.setItem("usertype", JSON.stringify(loginConfiguration.userType));
        localStorage.setItem("isVerticalTabPosition", loginConfiguration.isVerticalTabPosition);
        localStorage.setItem("decisionMaker", loginConfiguration.DecisionMaker);
        localStorage.setItem("isConcurrentSessionEnabled", loginConfiguration.isConcurrentSessionEnabled);
        setPageTitle(loginConfiguration.title);
        setUserType(loginConfiguration.userType);
        // Handle timeout
        const timeout = parseInt(loginConfiguration.defaultTimeout, 10);
        if (timeout > 0) {
          setDefaultTimeout(timeout);
          localStorage.setItem("defaultTimeout", timeout);
        }
        setLoginChecked && setLoginChecked(true);

        
        const signinlog = "SignIn, Success, HealthViewAnalyticsUI";
        validateLoginPrerequisite(signinlog)
          .then(() => {
            setLoginPrereqChecked && setLoginPrereqChecked(true);
          })
          .catch((error) => {
            if (error?.response?.data?.toLowerCase().trim() === "user is already login") {
              if (window.confirm("User is already logged in. End that session?")) {
                deletePreviousActiveUser(signinlog).then(() => {
                  navigate("/");
                });
              } else {
                localStorage.clear();
                sessionStorage.clear();
                if (instance) {
                  instance.logoutRedirect();
                }
              }
            }
            setLoginPrereqChecked && setLoginPrereqChecked(false);
          });
      })
      .catch(() => {
        setPageTitle("");
        setLoginChecked && setLoginChecked(false);
        setLoginPrereqChecked && setLoginPrereqChecked(false);
      });
      } else {
        // Already has SHVA, update active user
        console.log(' SHVA found. ');
        if(isAuthenticated && loginChecked &&loginPrereqChecked) {
          updateActiveUser("false").then(() => {
            // if Title is missing in localStorage, then try to get it from userType
            setPageTitle(localStorage.getItem("Title") || userType?.title || "");
          });
        }
        setLoginChecked && setLoginChecked(true);
        setLoginPrereqChecked && setLoginPrereqChecked(true);
      }

  
}, [isAuthenticated, loginChecked, loginPrereqChecked]);

 

  // Call init() after useLoginSuccess
  useEffect(() => {
    const init = async () => {
      let userTypeData = null;
      const userTypeStr = localStorage.getItem('usertype');
      if (userTypeStr) {
        userTypeData = JSON.parse(userTypeStr);
      } else {
        const result = await getUserType();
        userTypeData = result.data;
        localStorage.setItem('usertype', JSON.stringify(userTypeData));
      }
      if (userTypeData) {
        await configureLoginUser(userTypeData);
      }
      console.log("Default timeout:", defaultTimeout);
    };
    if (isAuthenticated && loginChecked && loginPrereqChecked) {
      init();
    }
  }, [isAuthenticated, loginChecked, loginPrereqChecked]);

  useEffect(() => {
    console.log("Default timeout updated:", defaultTimeout);
  },[defaultTimeout]);
// === Session Timeout Hook ===
  const { showSessionWarning, handleSessionContinue, timeLeft,resetSessionTimer } = useIdleSessionTimeout({
    sessionMinutes: localStorage.getItem("defaultTimeout") ? parseInt(localStorage.getItem("defaultTimeout"), 10) : defaultTimeout,
    warningSessionMinutes: powerBISettings.sessionTimeoutMessage,
    onLogout: () => handleLogout(),
  });
   useSessionExtensionInterceptor(resetSessionTimer);  
   // Reset extendClicked when warning disappears
  useEffect(() => {
    if (!showSessionWarning) {
      setExtendClicked(false);
    }
  }, [showSessionWarning]);
// Helper to check notification link
const checkNotificationLink = (isLinkEnable) => {
  if (isServiceAdmin) {
    setShowNotificationLink(true);
    setShowCustomQueryLink(true);
    return;
  }
  if (String(isLinkEnable).toLowerCase() === 'true') {
    setShowNotificationLink(true);
  } else {
    setShowNotificationLink(false);
  }
};

// Load tenants for service/support admin
const loadTenants = async () => {
  try {
    const result = await getCustomerTenants(false);
    setTenants(result.data || []);
    localStorage.setItem('tenants', JSON.stringify(result.data || []));
    if (result.data && userType?.userTenantAccessMappingExisting?.length > 0) {
      setShowNotificationLink(true);
      setShowCustomQueryLink(true);
    }
  } catch (error) {
    setTenants([]);
  }
};

// Populate notifications in panel
const populateNotificationsInPanel = (notifications) => {
  setNotificationForPanel(notifications || []);
};

// Main logic for configuring login user
const configureLoginUser = async (userTypeData) => {
  setUserType(userTypeData);
  setUserContext(userTypeData); // If using context for global user info

  setUserTypeAsParameter(
    userTypeData,
    userTypeData.tenantAdminUrlLinkCaption,
    userTypeData.tenantAdminUIUrl
  );

  const type = userTypeData.type?.toLowerCase();
  setIsServiceAdmin(type === 'serviceadmin');
  setIsTenantAdmin(type === 'tenantadmin');
  setIsSupportImplUser(!!userTypeData.isSupportImpl);

  setIsBackupCapacityActive(!!userTypeData.IsBackupCapacityActive);
  setUserId(Number(userTypeData.userId));
  setUserTenantId(Number(userTypeData.tenantId));
  setTenantAdminUrlCaption(userTypeData.tenantAdminUrlLinkCaption);
  setTenantAdminUrl(userTypeData.tenantAdminUIUrl);
  setShowTenantAdminLink(true);
  checkNotificationLink(userTypeData.reportNotification);
  setHvaObjectSubscriptionManagementDisplayName('Subscriptions Management');


  if(type !== 'serviceadmin' && type !== 'supportimpluser') {
    if(localStorage.getItem('jwt_authenticated') === 'true'){
      setRlsUser(localStorage.getItem('jwt_username'));
    }
    else{
      setRlsUser(accounts[0].username);
    }
  }
  setLoginConfigured(true);
};

useEffect(() => {
  async function runEffect() {
    if (!loginConfigured || !loginChecked || !loginPrereqChecked) return;
    // Prevent duplicate API calls by checking if userType.tenantId and userType.userId are valid and only call once
    if (!isServiceAdmin) {
      const notificationsArr = Array.isArray(userType.notifications) ? userType.notifications : [];
      setTenantNotifications(notificationsArr);
      if (notificationsArr.length > 0) {
        setShowNotificationPopUp(true);
      }
    }
    if (isServiceAdmin || isSupportImplUser) {
      setShowCustomQueryLink(true);
      setShowNotificationLink(true);
      if (isSupportImplUser && !userType.userTenantAccessMappingExisting) {
          
      }
      await loadTenants();
    } else {
        setShowTenantAdminLink(false);
        if(isTenantAdmin)
        {
          setShowTenantAdminLink(true);
          setShowCustomQueryLink(true);
          setShowNotificationLink(true);
        }
        // Only call getAllHVAObjectsOfUser if tenantId and userId are valid and not previously called
        if (userType.tenantId && userType.userId) {
          getAllHVAObjectsOfUser(userType.tenantId, userType.userId);
        }
        if(localStorage.getItem('jwt_authenticated') === 'true') {
          setRlsUser(localStorage.getItem('jwt_username'));
        } else {
          setRlsUser(accounts[0].username);
        }
    }
    populateNotificationsInPanel(userType.notificationForPanel);
    if (!isServiceAdmin && !isSupportImplUser) {
      try {
        const result = await getPowerBIAccessToken(userType.tenantId);
        setAccesstoken(JSON.stringify(result.data));
        setPowerBIAccessTokenTime(JSON.stringify(new Date()));
        localStorage.setItem('accesstoken', JSON.stringify(result.data));
        localStorage.setItem('powerBIAccessTokenTime', JSON.stringify(new Date()));
        if(localStorage.getItem('jwt_authenticated') === 'true'){
          setRlsUser(localStorage.getItem('jwt_username'));
        } else {
          setRlsUser(accounts[0].username);
        }
      } catch (error) {
        // Handle error
      }
    }
  }
  runEffect();
// Only run when loginConfigured, loginChecked, loginPrereqChecked change, not on pageTitle/defaultTimeout
}, [loginConfigured, isServiceAdmin, isSupportImplUser, userType, loginChecked, loginPrereqChecked]);

const getAllHVAObjectsOfUser = async (tenantId, userId) => {
  try {
    const result = await getHVAObjectListForUser(tenantId, userId);
    const allHvaObjects = result.data || [];
    const nonProductObjects = allHvaObjects.filter(e => e.ObjectType !== "Product");


    GetNonProductObjects(nonProductObjects);
  } catch (error) {
    // Handle error
  }
};

const GetNonProductObjects = (nonProductObjects) => {
  let objPrivilege = {};
  let hvaObjectSubscriptionManagementDisplayNameLocal = "";
  const HVAObjectSubscriptionManagementName = "Subscriptions Management"; // Adjust as needed

  nonProductObjects.forEach(hvaObjectType => {
    const hvaObjectList = hvaObjectType.HVAObjectList || [];
    hvaObjectList.forEach(hvaObject => {
      if (hvaObject && hvaObject.ObjectName === HVAObjectSubscriptionManagementName) {
        hvaObjectSubscriptionManagementDisplayNameLocal = hvaObject.ObjectDisplayName;
        (hvaObject.PrivilegeList || []).forEach(privilege => {
          objPrivilege[privilege.Type] = privilege.GrantFlag;
        });

        // Set privileges for this object: objectName as key and objPrivilege as value
        setSubscriptionMngtPrivileges(objPrivilege);

        // Show notification link if Manage privilege exists
        if (objPrivilege.Manage !== undefined) {
          setShowNotificationLink(true);
        }
      } 
    });
  });

  // Optionally add scroll logic for left navigation here
  // AddScrolltoLeftNavigation();
  setHvaObjectSubscriptionManagementDisplayName(hvaObjectSubscriptionManagementDisplayNameLocal);

  // Check whether user is member of any subscription
  if (objPrivilege.Manage === undefined) {
     CheckUserIsMemberOfAnySubscription();
  }

  
};
useEffect(() => {
  console.log('privileges', subscriptionMngtPrivileges);
}, [subscriptionMngtPrivileges]);

// React version of CheckUserIsMemberofAnySubscription
const CheckUserIsMemberOfAnySubscription = async () => {
  try {
    const result = await getReportNotificationsIAmMemberOf(userType.tenantId, userType.userId);
    if (result.data.length > 0) {
      setHvaObjectSubscriptionManagementDisplayName(HVAObjectSubscriptionManagementName);
      setShowNotificationLink(true);
      //UpdateShowNotificationLink(true);
    }
  } catch (error) {
    // Optionally handle error
  }
};


 const handleTenantChange = async (event) => {
  setSelectedTenant(event.target.value);
  //console.log("Selected Tenant changed to:", event.target.value);
  if(event.target.value === "Select Tenant") {
    setAccesstoken('');
    setPowerBIAccessTokenTime('');
    localStorage.setItem('accesstoken', '');
    localStorage.setItem('powerBIAccessTokenTime', '');
    setPageTitle(localStorage.getItem("Title") || "");
    return;
  }
  try {
    const tenantObj = tenants.find(e => e.TenantId === event.target.value);
    if (tenantObj && tenantObj.TenantAdmin) {
      setRlsUser(tenantObj.TenantAdmin.Upn);
    }

    var oldTitle = pageTitle;
    var selectedTenantText = tenantObj ? tenantObj.DisplayName : event.target.value;
    var arrTitle = oldTitle.split(" - ");
    var newTitle = selectedTenantText + ' - ' + arrTitle[1];
    setPageTitle(newTitle);

    const result = await getPowerBIAccessToken(event.target.value);
    setAccesstoken(JSON.stringify(result.data));
    setPowerBIAccessTokenTime(JSON.stringify(new Date()));
    localStorage.setItem('accesstoken', JSON.stringify(result.data));
    localStorage.setItem('powerBIAccessTokenTime', JSON.stringify(new Date()));

  } catch (error) {
    // Handle error
  }
  // Add any additional logic you want to run on tenant change here
};

const handleNavigateToTenantAdmin = async () => {
  let redirectURL = "";
  try {
    if (!await validateConcurrentSessionIfEnabled()) {  
                return;  
    }
    // Get tokens from localStorage
    const idpToken = localStorage.getItem('customidp');
    const jwtToken = localStorage.getItem('jwttoken');
    const decisionMaker = localStorage.getItem('decisionMaker');
    // Use state for tenantAdminUrl
    //let tenantAdminUrl1 = "http://localhost:50812/#/tenantadmin/facilities";;
    if (tenantAdminUrl) {
      // If you have a globalRedirectURL and customIDPAuthenticationService.validateCustomIDPAuthentication()
      // Replace these with your React equivalents or props/context
      //const globalRedirectURL = localStorage.getItem('postLogoutRedirectUri'); // Or from context/props
      //if (globalRedirectURL && globalRedirectURL !== '') {
        if (jwtToken && jwtToken.trim() !== '' && jwtToken !== null && idpToken && idpToken.trim() !== '' && idpToken !== null) {
          redirectURL = `${tenantAdminUrl}?shva=${encodeURIComponent(localStorage.getItem('shva'))}&customidp=${encodeURIComponent(idpToken)}&jwttoken=${encodeURIComponent(jwtToken)}&decisionMaker=${encodeURIComponent(decisionMaker)}`;
        } else {
          redirectURL = `${tenantAdminUrl}?shva=${encodeURIComponent(localStorage.getItem('shva'))}`;
        }
     // } else {
       // redirectURL = `${tenantAdminUrl}`;
     // }
      console.log("Redirecting to Tenant Admin URL:", redirectURL);

    }
    // Call your logout logic here
   // await logoutCleanup(shvaToken, '', navigate);
    // Clear sessionStorage
    sessionStorage.clear();
    // Redirect
    window.location.href = redirectURL;
  } catch (e) {
    alert(e);
  } finally {
    // Remove specific localStorage items
    if (localStorage.getItem('shva')) localStorage.removeItem('shva');
    if (localStorage.getItem('currentNavigationLink')) localStorage.removeItem('currentNavigationLink');
  }
};

const handleContentPackViewEvent = async (event) => {
setContentPackListPinned(event);
setShowMgtConsole(true);
setShowSubscriptionMgt(false);
setShowCustomQueryBuilder(false);
  // Toggle menu in Report if visible
  if (reportRef.current && typeof reportRef.current.toggleMenu === 'function' && showMgtConsole) {
    reportRef.current.toggleMenu();
  }
};


// Callback to set showTenantAdminLink from child components (e.g., Report)
const handleSetShowTenantAdminLink = (value) => {
  setShowTenantAdminLink(value);
};

const handleSetShowCustomQueryLink = (value) => {
  setShowCustomQueryLink(value);
};

  // Clear localStorage on browser close (not just new session)
useEffect(() => {
  const handleBeforeUnload = () => {      
    // Preserve essential values BEFORE clearing  
    const essentialValues = {  
      defaultTimeout: localStorage.getItem('defaultTimeout'),  
      usertype: localStorage.getItem('usertype'),  
      Title: localStorage.getItem('Title'),  
      // Additional values to preserve  
      IsNotificationShown: localStorage.getItem('IsNotificationShown'),  
      decisionMaker: localStorage.getItem('decisionMaker'),  
      isVerticalTabPosition: localStorage.getItem('isVerticalTabPosition'),  
      postLogoutRedirectUri: localStorage.getItem('postLogoutRedirectUri'),  
      tenants: localStorage.getItem('tenants') ,
       shva: localStorage.getItem('shva'), 
    };   
      
    console.log('Clearing localStorage except essential values');  
    removeLocalStorageItems();  
    localStorage.clear();  
      
    // Restore essential values after clearing  
    Object.entries(essentialValues).forEach(([key, value]) => {  
      if (value) {  
        localStorage.setItem(key, value);  
        console.log(`Restored ${key} in localStorage:`, value);  
      }  
    });  
  };  
    
  window.addEventListener('beforeunload', handleBeforeUnload);  
  return () => window.removeEventListener('beforeunload', handleBeforeUnload);  
}, []);

// Clear localStorage on new browser session (browser close/reopen)  
/* useEffect(() => {  
  if (!sessionStorage.getItem('sessionActive')) {  
    console.log('New browser session detected. Clearing localStorage.');
    // Preserve JWT authentication data  
    const jwtToken = localStorage.getItem('jwttoken');  
    const customIdp = localStorage.getItem('customidp');  
    const jwtAuthenticated = localStorage.getItem('jwt_authenticated');  
    const jwtUsername = localStorage.getItem('jwt_username');  
    removeLocalStorageItems();
    localStorage.clear();  
    // Restore JWT data if present
    if (jwtToken && jwtToken.trim() !== '' && jwtToken !== null && customIdp && customIdp.trim() !== '' && customIdp !== null && jwtAuthenticated === 'true') {
      localStorage.setItem('jwttoken', jwtToken);
      localStorage.setItem('customidp', customIdp);
      localStorage.setItem('jwt_authenticated', jwtAuthenticated);
      localStorage.setItem('jwt_username', jwtUsername);
    }

    sessionStorage.setItem('sessionActive', 'true');
  }
}, []); */

  // Convert to React JS style
  const GetandOpenSupportURL = async () => {
  try {
    const tableDetails = {
      product: "hva",
      module: "contentpacks",
      section: "home"
    };
    const result = await openFlareDocument(tableDetails);
    const newlink = result.data;
    window.open(newlink, '_blank');
  } catch (error) {
    // Optionally show a user-friendly error message here
    console.error("Failed to open support URL:", error);
  }
};

  // === Render ===
  return (
    <div>
      {/* ====== Header ====== */}
      <Header
        pageTitle={pageTitle}
        isAuthenticated={isAuthenticated}
        openNotificationPanel={openNotificationPanel}
        handleLogout={handleLogout}
        handleLogin={handleLogin}
        showNotificationLink={showNotificationLink}
         notificationForPanel = {notificationForPanel}
         openSupportURL={GetandOpenSupportURL}
      />
      <SubHeader
        isAuthenticated={isAuthenticated}
        pageTitle={pageTitle}
        userType={userType}
        tenants={(isServiceAdmin || isSupportImplUser) ? tenants : []}
        selectedTenant={selectedTenant}
        handleTenantChange={handleTenantChange}
        handleContentPackViewEvent={handleContentPackViewEvent}
        handleNavigateToTenantAdmin={handleNavigateToTenantAdmin}
        showTenantAdminLink={showTenantAdminLink}
        showNotificationLink={showNotificationLink}
        showCustomQueryBuilderLink={showCustomQueryLink}
        onSubscriptionMgtClick={() => {
          setShowSubscriptionMgt(true);
          setShowCustomQueryBuilder(false);
          setShowMgtConsole(false);
        }}
        onCustomQueryBuilderClick={() => {
          setShowCustomQueryBuilder(true);
          setShowSubscriptionMgt(false);
          setShowMgtConsole(false);
        }}
        resetSessionTimer={resetSessionTimer}
      />
      {/* ====== Session Timeout Warning ====== */}
      {showSessionWarning && (
        <Box sx={{
          position: 'absolute',
          top: '90px',
          //left: '20%',
          transform: 'translateX(50%)',
          width: '100%',
          //maxWidth: 1024,
          zIndex: 9999999
        }}>
          <Snackbar
            open={showSessionWarning}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{
              position: 'static',
              width: '100%',
              opacity: 1,
              pointerEvents: 'none',
              minHeight: 'unset',
              height: 'unset',
              p: 0
            }}
            style={{ width: '100%' }}
          >
            <Alert
              severity="warning"
              sx={{
                background: 'rgba(255,251,230,0.95)',
                color: '#333',
                borderBottom: '1px solid #ffe58f',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'auto',
                flexDirection: 'row',
                padding: '4px 8px',
                minHeight: '32px',
                height: '32px',
              }}
              action={null}
            >
              <span style={{ marginLeft: 0, fontSize: 14 }}>
                Your session will expire in {Math.floor(timeLeft / 60000)} min {Math.floor((timeLeft % 60000) / 1000)} sec.
              </span>
              <Button 
                variant="contained"
                color="inherit"
                size="small"
                onClick={() => { setExtendClicked(true); handleSessionContinue(); }} 
                disabled={extendClicked}
                sx={{ ml: 2, backgroundColor: '#888', color: '#fff', boxShadow: 'none', textTransform: 'none', minWidth: 100, height: '28px', fontSize: 13, p: '2px 10px' }}
              >
                Extend Session
              </Button>
            </Alert>
          </Snackbar>
        </Box>
      )}
      {/* ====== Main Content ====== */}
      <div className="mainContent" style={{ minHeight: 'calc(97vh - 100px)', width: '100%', boxSizing: 'border-box', overflow: 'auto', position: 'relative' }}>
        {showSubscriptionMgt && (
          <SubscriptionMgtMain 
            isAuthenticated={isAuthenticated}
            userType={userType}
            selectedTenant={selectedTenant}
            accesstoken={accesstoken}
            powerBIAccessTokenTime={powerBIAccessTokenTime}
            rlsUser={rlsUser}
            userId={userId}
            isServiceAdmin={isServiceAdmin}
            isSupportImplUser={isSupportImplUser}
            isTenantAdmin={isTenantAdmin}
            isBackupCapacityActive={isBackupCapacityActive}
            userTenantId={userTenantId}
            privileges={subscriptionMngtPrivileges}
            resetSessionTimer={resetSessionTimer}
          />
        )}
        {showMgtConsole && (
          <Report
            ref={reportRef}
            isAuthenticated={isAuthenticated}
            userType={userType}
            selectedTenant={selectedTenant}
            accesstoken={accesstoken}
            powerBIAccessTokenTime={powerBIAccessTokenTime}
            rlsUser={rlsUser}
            userId={userId}
            isServiceAdmin={isServiceAdmin}
            isSupportImplUser={isSupportImplUser}
            isTenantAdmin={isTenantAdmin}
            IsBackupCapacityActive={isBackupCapacityActive}
            userTenantId={userTenantId}
            handleSetShowTenantAdminLink={handleSetShowTenantAdminLink}
            handleSetShowCustomQueryLink={handleSetShowCustomQueryLink}
          />
        )}
        {showCustomQueryBuilder && (
          <QueryBuilder 
              isAuthenticated={isAuthenticated}
              userType={userType}
              selectedTenant={selectedTenant}
              userId={userId}
              userTenantId={userTenantId}
              />
        )}
      </div>
      <Footer />

      {/* ====== Error Alert ====== */}
      <div className="col-sm-12 erroralert" style={{ overflow: "auto" }}>
        {errorMessage && (
          <div className="alert alert-danger col-sm-12 fade in">
            <span>{errorMessage}</span>
            {errorDetail && (
              <span
                onClick={() => setShowErrorDetail(!showErrorDetail)}
                style={{ cursor: "pointer" }}
              >
                {!showErrorDetail ? (
                  <span
                    className="glyphicon glyphicon-triangle-bottom"
                    title="click to show error details"
                  ></span>
                ) : (
                  <span
                    className="glyphicon glyphicon-triangle-top"
                    title="click to hide error details"
                  ></span>
                )}
              </span>
            )}
            <div className="row">
              <div
                className="col-sm-12"
                style={{ display: showErrorDetail ? "block" : "none" }}
              >
                {errorDetail}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ====== Notification Panel ====== */}
      <NotificationMessagePopup open={showNotificationPopUp}  onClose={() => setShowNotificationPopUp(false)} tenantNotifications={tenantNotifications} />
    </div>
  );
}

export default Home;
